import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/Rx';
import { car } from '../../../models/plan/car';
import { ColorDetail } from '../../../models/plan/color-detail.model';
import { Customer } from '../../../models/plan/customer';
import { Dop } from './../../../models/plan/dop';
import { hanbaitenOption } from './../../../models/plan/hanbaitenOption';
import { Hop } from './../../../models/plan/hop';
import { Mop } from './../../../models/plan/mop';
import { Recycle } from './../../../models/plan/recycle';
import { Car1, Car2, Shitadori } from './../../../models/plan/shitadori';
import { Shohiyo } from './../../../models/plan/shohiyo.model';
import { Tax } from './../../../models/plan/tax';
import { ShohiyoHikazei } from './../../../models/plan/ShohiyoHikazei';
import { ShohiyouKazei } from '../../../models/plan/companylist.model';

@Injectable()
export class PlantwoService {
  // public carAPI: car = {};
  public customerAPI: Customer = {};
  public car1: Car1 = {};
  public car2: Car2 = {};
  public shitadori: Shitadori = {};
  public recycles: Recycle = {};
  public tax: Tax = {};
  public hanbaitenOptions: hanbaitenOption = {};
  public hop: Hop = {};
  public mop: Mop = {};
  public dop: Dop = {};
  public shohiyo: Shohiyo[] = [];
  public shohiyouKazei: Shohiyo[] = [];

  public pricezk = 0;
  public pricezn = 0;

  public creditCompany2: any;
  public loanPlan2: any;
  public loanOneAtamakin2;

  /////  BehaviorSubject
  customersSubject: BehaviorSubject<Customer> = new BehaviorSubject<Customer>(
    null
  );
  // carAPISubject: BehaviorSubject<car> = new BehaviorSubject<car>(null);
  shitadoriSubject: BehaviorSubject<Shitadori> = new BehaviorSubject<Shitadori>(
    null
  );
  recyclesSubject: BehaviorSubject<Recycle> = new BehaviorSubject<Recycle>(
    null
  );
  taxSubject: BehaviorSubject<Tax> = new BehaviorSubject<Tax>(null);
  hanbaitenOptionsSubject: BehaviorSubject<
    hanbaitenOption
  > = new BehaviorSubject<hanbaitenOption>(null);
  hopSubject: BehaviorSubject<Hop> = new BehaviorSubject<Hop>(null);
  mopSubject: BehaviorSubject<Mop> = new BehaviorSubject<Mop>(null);
  dopSubject: BehaviorSubject<Dop> = new BehaviorSubject<Dop>(null);
  chosenDealerItemSelected = new BehaviorSubject<any>([]);
  dopSave = new BehaviorSubject<any>([]);
  doploanflags = new BehaviorSubject<any>([]);
  shohiyoSubject: BehaviorSubject<Shohiyo> = new BehaviorSubject<Shohiyo>(null);
  shohiyouKazeiSubject: BehaviorSubject<Shohiyo> = new BehaviorSubject<Shohiyo>(
    null
  );
  carColorSelected: BehaviorSubject<ColorDetail> = new BehaviorSubject<
    ColorDetail
  >(null);

  // shohiyouKazeiPayment1 = new BehaviorSubject(null);
  shohiyouHikazeiPayment1 = new BehaviorSubject(null);
  leaseShohiyouKazei1 = new BehaviorSubject(null);

  isSetCarInfo = false;

  constructor() {}

  setPriceZkPlanone = (value: number) => {
    this.pricezk = value;
  };
  setPriceZnPlanone = (value: number) => {
    this.pricezn = value;
  };

  // setCarService = (carservice: car) => {
  //   if (carservice === null) {
  //     this.carAPI = null;
  //   } else {
  //     this.carAPI = Object.assign({}, carservice);
  //   }
  // };

  // setCarSubject = (carservice: car) => {
  //   const changedCar = { ...carservice };
  //   this.carAPISubject.next(changedCar);
  // };

  // getCarService = () => {
  //   return this.carAPI;
  // };

  setCustomerService = (customer: Customer) => {
    this.customerAPI = Object.assign({}, customer);
  };

  setCustomerSubject = (customer: Customer) => {
    this.customersSubject.next(customer);
  };

  getCustomer = () => {
    return this.customerAPI;
  };

  setCar1Service = (car1service: Car1) => {
    this.car1 = car1service;
  };

  getCar1Service = () => {
    return this.car1;
  };

  setCar2Service = (car2service: Car2) => {
    this.car2 = car2service;
  };

  getCar2Service = () => {
    return this.car2;
  };

  setShitadoriService = (shitadori: Shitadori) => {
    this.shitadori = Object.assign({}, shitadori);
  };

  setshitadoriSubject = (shitadori: Shitadori) => {
    this.shitadoriSubject.next(shitadori);
  };

  getShitadoriService = () => {
    return this.shitadori;
  };

  setrecycleService = (recycle: Recycle) => {
    this.recycles = Object.assign({}, recycle);
  };

  setrecyclesSubject = (recycle: Recycle) => {
    this.recyclesSubject.next(recycle);
  };

  getRecycle = () => {
    return this.recycles;
  };

  settaxService = (tax: Tax) => {
    this.tax = Object.assign({}, tax);
  };

  settaxSubject = (tax: Tax) => {
    this.taxSubject.next(tax);
  };

  getTaxService = () => {
    return this.tax;
  };

  sethanbaitenOption = (hanbaitenOption: hanbaitenOption) => {
    this.hanbaitenOptions = Object.assign({}, hanbaitenOption);
  };

  getHanbaitenOption = () => {
    return this.hanbaitenOptions;
  };

  setHop = (hop: Hop) => {
    this.hop = Object.assign({}, hop);
  };

  getHopService = () => {
    return this.hop;
  };

  setMop = (mop: Mop) => {
    this.mop = Object.assign({}, mop);
  };

  getMop = () => {
    return this.mop;
  };

  setDop = (dop: Dop) => {
    this.dop = Object.assign({}, dop);
    this.dopSubject.next({ ...dop });
  };

  getDop = () => {
    return this.dop;
  };

  setShohiyo = (shohiyo: ShohiyoHikazei[]) => {
    this.shohiyo = Object.assign([], shohiyo);
  };

  getShohiyo = () => {
    return this.shohiyo;
  };

  setshohiyouKazei = (shohiyouKazei: ShohiyouKazei[]) => {
    this.shohiyouKazei = Object.assign([], shohiyouKazei);
  };

  getshohiyouKazei = () => {
    return this.shohiyouKazei;
  };

  setchosenCreditCompany(value) {
    this.creditCompany2 = value;
  }

  setchosenLoanPlan(value) {
    this.loanPlan2 = value;
  }

  getCreditCompany2() {
    return this.creditCompany2;
  }

  getLoanPlan2() {
    return this.loanPlan2;
  }

  setloanOneAtamakin(value) {
    this.loanOneAtamakin2 = value;
  }

  getloanOneAtamakin() {
    return this.loanOneAtamakin2;
  }

  setCarColor = (colorSelected: ColorDetail) => {
    this.carColorSelected.next(colorSelected);
  };

  onResetData() {
    this.setCar1Service(null);
    this.setCar2Service(null);
    this.setCarColor(null);
    // this.setCarService({});
    // this.setCarSubject(null);
    // this.setchosenCreditCompany(null);
    // this.setchosenLoanPlan(null);
    this.setCustomerService(null);
    this.setCustomerSubject(null);
    this.setDop(null);
    this.sethanbaitenOption(null);
    this.setHop(null);
    // this.setloanOneAtamakin(null);
    this.setMop(null);
    this.setrecycleService(null);
    this.settaxService(null);
    this.setPriceZkPlanone(null);
    this.setPriceZnPlanone(null);
    this.setrecyclesSubject(null);
    this.setShitadoriService(null);
    this.setshitadoriSubject(null);
    this.setShohiyo(null);
    this.setshohiyouKazei(null);
    this.settaxSubject(null);
    this.isSetCarInfo = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/plantwo/services/plantwo.service.ts